<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <card
          color="green"
          title="Branchen Liste"
        >
          <v-data-table
            :headers="headers"
            :items="companies"
            hide-actions
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.title }}</td>
              <td><v-icon>{{ props.item.icon }}</v-icon> ({{ props.item.icon }})</td>
              <td width="156">
                <dlg-branch-edit :branch="props.item"/>
                <dlg-branch-delete :branch="props.item"/>
              </td>
            </template>
          </v-data-table>
        </card>
      </v-flex>
    </v-layout>

    <dlg-branch-new/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DlgBranchEdit from '@/modules/branch/_components/DlgBranchEdit';
import DlgBranchDelete from '@/modules/branch/_components/DlgBranchDelete';
import DlgBranchNew from '@/modules/branch/_components/DlgBranchNew';
import Card from '../../../components/material/Card';

export default {
  name: 'branchList',
  components: {
    Card,
    DlgBranchNew,
    DlgBranchDelete,
    DlgBranchEdit,
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'title',
        },
        {
          text: 'Icon',
          align: 'left',
          sortable: false,
          value: 'email',
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: '',
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      companies: 'branch/all',
    }),
  },
  methods: {
    ...mapActions({
      readBranches: 'branch/read',
    }),
  },
  mounted() {
    this.loading = true;
    this.readBranches().then(() => {
      this.loading = false;
    });
  },
};
</script>

<style scoped>

</style>
